import type { RouteObject } from "src/router";
import { lazyNamed } from "src/utils/lazy-named";

const Setup = lazyNamed(() => import("./setup-page"), "Setup");

export const routes: Array<RouteObject> = [
  {
    path: "onboarding/*",
    element: <Setup />,
    spacesAccess: "hidden-from-limited-view",
  },
];
